import React from 'react';

import Avatar from '@atlaskit/avatar/Avatar';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { AudioFeature } from '../../../types/audioFeature';
import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';

import { AudioIconStack } from './AudioIconStack';

export type AudioHeaderProps = {
	featureList: AudioFeature[];
};

const styles = cssMap({
	iconTileContainer: {
		marginBlockEnd: token('space.200'),
	},
});

export const AudioHeader = ({ featureList }: AudioHeaderProps): React.JSX.Element => {
	const { activeContent, pendingContent } = useAudioPlayerStore();

	const contentTitle = pendingContent?.title || activeContent.title || 'Untitled';
	const contentAuthor = pendingContent?.author ?? activeContent.author ?? '';
	const contentAvatarUrl = pendingContent?.avatarUrl ?? activeContent.avatarUrl ?? '';

	return (
		<Box>
			<Box xcss={styles.iconTileContainer}>
				<AudioIconStack featureList={featureList} />
			</Box>

			<Stack alignInline="center" space="space.050">
				<Heading size="medium">{contentTitle}</Heading>
				<Inline space="space.075" alignBlock="center">
					<Avatar src={contentAvatarUrl} size="xsmall" />
					<Text color="color.text.subtlest" maxLines={1}>
						{contentAuthor}
					</Text>
				</Inline>
			</Stack>
		</Box>
	);
};
